import { IconProps } from "@design-system/types";

export function InvestmentIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.125 8.70831L11.275 12.5583L9.80833 10.3583L6.875 13.2916"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2917 8.70831H15.1251V10.5416"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24992 20.1666H13.7499C18.3333 20.1666 20.1666 18.3333 20.1666 13.75V8.24998C20.1666 3.66665 18.3333 1.83331 13.7499 1.83331H8.24992C3.66659 1.83331 1.83325 3.66665 1.83325 8.24998V13.75C1.83325 18.3333 3.66659 20.1666 8.24992 20.1666Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
